/**
 * Meta Pixel (Facebook Pixel) ヘルパー
 *
 * VITE_META_PIXEL_ID が設定されている場合のみ計測する。
 * 未設定時は console.debug で済ませてエラーにしない。
 */

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _fbq?: any;
  }
}

// Pixel ID は公開情報（ブラウザに露出する）なのでフォールバックをコードに置く。
// 別ピクセルに切り替えたい場合は .env で VITE_META_PIXEL_ID を上書き可能。
const DEFAULT_PIXEL_ID = "1548384990051872";
const PIXEL_ID =
  (import.meta.env.VITE_META_PIXEL_ID as string | undefined) || DEFAULT_PIXEL_ID;

let injected = false;

/** fbevents.js を <head> に動的注入する。idempotent。 */
export function initMetaPixel(): void {
  if (typeof window === "undefined") return;
  if (injected) return;
  if (!PIXEL_ID) {
    console.debug("[meta-pixel] VITE_META_PIXEL_ID 未設定。計測スキップ");
    return;
  }
  injected = true;

  // Standard Meta Pixel base code, ported to a TS-friendly form.
  /* eslint-disable @typescript-eslint/no-explicit-any */
  (function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return;
    const n: any = (f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode?.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable @typescript-eslint/no-explicit-any */

  window.fbq("init", PIXEL_ID);
  // 初回 PageView。以降の SPA 遷移は trackMetaPageView() で発火。
  window.fbq("track", "PageView");
}

/** SPA ルート遷移時の PageView */
export function trackMetaPageView(): void {
  if (typeof window === "undefined" || !window.fbq) return;
  window.fbq("track", "PageView");
}

/** 標準イベント送信 */
export function trackMetaEvent(
  eventName: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === "undefined" || !window.fbq) {
    console.debug(`[meta-pixel] track(${eventName})`, params);
    return;
  }
  window.fbq("track", eventName, params ?? {});
}
